module.exports = __webpack_public_path__ + "media/giftcards/GC-Include-1-029236d7.svg";